import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import TreeSet from '../../../../java/util/TreeSet';
import Geometry from './Geometry';
import Arrays from '../../../../java/util/Arrays';
import CoordinateFilter from './CoordinateFilter';
import hasInterface from '../../../../hasInterface';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import GeometryComponentFilter from './GeometryComponentFilter';
import Dimension from './Dimension';
import ArrayList from '../../../../java/util/ArrayList';
import GeometryFilter from './GeometryFilter';
import CoordinateSequenceFilter from './CoordinateSequenceFilter';
import Envelope from './Envelope';
import Assert from '../util/Assert';
var GeometryCollection = /*#__PURE__*/function (_Geometry) {
  _inherits(GeometryCollection, _Geometry);
  function GeometryCollection() {
    var _this;
    _classCallCheck(this, GeometryCollection);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(GeometryCollection).call(this));
    GeometryCollection.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(GeometryCollection, [{
    key: "computeEnvelopeInternal",
    value: function computeEnvelopeInternal() {
      var envelope = new Envelope();
      for (var i = 0; i < this._geometries.length; i++) envelope.expandToInclude(this._geometries[i].getEnvelopeInternal());
      return envelope;
    }
  }, {
    key: "getGeometryN",
    value: function getGeometryN(n) {
      return this._geometries[n];
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      var coordinates = new Array(this.getNumPoints()).fill(null);
      var k = -1;
      for (var i = 0; i < this._geometries.length; i++) {
        var childCoordinates = this._geometries[i].getCoordinates();
        for (var j = 0; j < childCoordinates.length; j++) {
          k++;
          coordinates[k] = childCoordinates[j];
        }
      }
      return coordinates;
    }
  }, {
    key: "getArea",
    value: function getArea() {
      var area = 0.0;
      for (var i = 0; i < this._geometries.length; i++) area += this._geometries[i].getArea();
      return area;
    }
  }, {
    key: "copyInternal",
    value: function copyInternal() {
      var geometries = new Array(this._geometries.length).fill(null);
      for (var i = 0; i < geometries.length; i++) geometries[i] = this._geometries[i].copy();
      return new GeometryCollection(geometries, this._factory);
    }
  }, {
    key: "equalsExact",
    value: function equalsExact() {
      if (arguments.length === 2 && typeof arguments[1] === 'number' && arguments[0] instanceof Geometry) {
        var other = arguments[0],
          tolerance = arguments[1];
        if (!this.isEquivalentClass(other)) return false;
        var otherCollection = other;
        if (this._geometries.length !== otherCollection._geometries.length) return false;
        for (var i = 0; i < this._geometries.length; i++) if (!this._geometries[i].equalsExact(otherCollection._geometries[i], tolerance)) return false;
        return true;
      } else {
        return _get(_getPrototypeOf(GeometryCollection.prototype), "equalsExact", this).apply(this, arguments);
      }
    }
  }, {
    key: "normalize",
    value: function normalize() {
      for (var i = 0; i < this._geometries.length; i++) this._geometries[i].normalize();
      Arrays.sort(this._geometries);
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (this.isEmpty()) return null;
      return this._geometries[0].getCoordinate();
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      var dimension = Dimension.FALSE;
      for (var i = 0; i < this._geometries.length; i++) dimension = Math.max(dimension, this._geometries[i].getBoundaryDimension());
      return dimension;
    }
  }, {
    key: "reverseInternal",
    value: function reverseInternal() {
      var numGeometries = this._geometries.length;
      var reversed = new ArrayList(numGeometries);
      for (var i = 0; i < numGeometries; i++) reversed.add(this._geometries[i].reverse());
      return this.getFactory().buildGeometry(reversed);
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return Geometry.TYPECODE_GEOMETRYCOLLECTION;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      var dimension = Dimension.FALSE;
      for (var i = 0; i < this._geometries.length; i++) dimension = Math.max(dimension, this._geometries[i].getDimension());
      return dimension;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      var sum = 0.0;
      for (var i = 0; i < this._geometries.length; i++) sum += this._geometries[i].getLength();
      return sum;
    }
  }, {
    key: "getNumPoints",
    value: function getNumPoints() {
      var numPoints = 0;
      for (var i = 0; i < this._geometries.length; i++) numPoints += this._geometries[i].getNumPoints();
      return numPoints;
    }
  }, {
    key: "getNumGeometries",
    value: function getNumGeometries() {
      return this._geometries.length;
    }
  }, {
    key: "compareToSameClass",
    value: function compareToSameClass() {
      if (arguments.length === 1) {
        var o = arguments[0];
        var theseElements = new TreeSet(Arrays.asList(this._geometries));
        var otherElements = new TreeSet(Arrays.asList(o._geometries));
        return this.compare(theseElements, otherElements);
      } else if (arguments.length === 2) {
        var _o = arguments[0],
          comp = arguments[1];
        var gc = _o;
        var n1 = this.getNumGeometries();
        var n2 = gc.getNumGeometries();
        var i = 0;
        while (i < n1 && i < n2) {
          var thisGeom = this.getGeometryN(i);
          var otherGeom = gc.getGeometryN(i);
          var holeComp = thisGeom.compareToSameClass(otherGeom, comp);
          if (holeComp !== 0) return holeComp;
          i++;
        }
        if (i < n1) return 1;
        if (i < n2) return -1;
        return 0;
      }
    }
  }, {
    key: "apply",
    value: function apply() {
      if (hasInterface(arguments[0], CoordinateFilter)) {
        var filter = arguments[0];
        for (var i = 0; i < this._geometries.length; i++) this._geometries[i].apply(filter);
      } else if (hasInterface(arguments[0], CoordinateSequenceFilter)) {
        var _filter = arguments[0];
        if (this._geometries.length === 0) return null;
        for (var _i = 0; _i < this._geometries.length; _i++) {
          this._geometries[_i].apply(_filter);
          if (_filter.isDone()) break;
        }
        if (_filter.isGeometryChanged()) this.geometryChanged();
      } else if (hasInterface(arguments[0], GeometryFilter)) {
        var _filter2 = arguments[0];
        _filter2.filter(this);
        for (var _i2 = 0; _i2 < this._geometries.length; _i2++) this._geometries[_i2].apply(_filter2);
      } else if (hasInterface(arguments[0], GeometryComponentFilter)) {
        var _filter3 = arguments[0];
        _filter3.filter(this);
        for (var _i3 = 0; _i3 < this._geometries.length; _i3++) this._geometries[_i3].apply(_filter3);
      }
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      Geometry.checkNotGeometryCollection(this);
      Assert.shouldNeverReachHere();
      return null;
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return Geometry.TYPENAME_GEOMETRYCOLLECTION;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      for (var i = 0; i < this._geometries.length; i++) if (!this._geometries[i].isEmpty()) return false;
      return true;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._geometries = null;
      if (arguments.length === 0) {} else if (arguments.length === 2) {
        var geometries = arguments[0],
          factory = arguments[1];
        Geometry.constructor_.call(this, factory);
        if (geometries === null) geometries = [];
        if (Geometry.hasNullElements(geometries)) throw new IllegalArgumentException('geometries must not contain null elements');
        this._geometries = geometries;
      }
    }
  }]);
  return GeometryCollection;
}(Geometry);
export { GeometryCollection as default };